import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { Popover, PopoverModule } from 'primeng/popover';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { Destroyable } from '@shared/utils/destroyable';
import { takeUntil } from 'rxjs';
import { NotificationStore } from '../../services/notification.store';
import { NotificationEntity } from '../../models';
import { NotificationItemComponent } from '../notification-item/notification-item.component';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    ButtonModule,
    BadgeModule,
    PopoverModule,
    ProgressSpinnerModule,
    RippleModule,
    NotificationItemComponent,
  ],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationBellComponent extends Destroyable {
  private readonly store = inject(NotificationStore);
  private readonly router = inject(Router);

  readonly notifications = this.store.notifications;
  readonly unreadCount = this.store.unreadCount;
  readonly hasUnread = this.store.hasUnread;
  readonly loading = this.store.loading;
  readonly isEmpty = this.store.isEmpty;

  @ViewChild('panel') panel!: Popover;

  toggle(event: Event): void {
    this.panel.toggle(event);
  }

  onMarkAllAsRead(): void {
    this.store.markAllAsRead().pipe(takeUntil(this.destroyed$)).subscribe();
  }

  onItemRead(notification: NotificationEntity): void {
    if (!notification.isUnread) return;
    this.store.markAsRead(notification.id).pipe(takeUntil(this.destroyed$)).subscribe();
  }

  onItemClicked(notification: NotificationEntity): void {
    if (notification.isUnread) {
      this.store.markAsRead(notification.id).pipe(takeUntil(this.destroyed$)).subscribe();
    }
    if (notification.link) {
      this.router.navigateByUrl(notification.link);
    }
    this.panel.hide();
  }

  onViewAll(): void {
    this.router.navigate(['/notifications']);
    this.panel.hide();
  }
}
